'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React from 'react';
import { findClosestGlyphAvailable, Icon, IconSizeMap } from "../../index.mjs";
export function IconPlaybackSpeed1Point5x(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M10.82.5h3.749V2h-2.555l-.188.82a2.76 2.76 0 0 1 .647-.075c1.515 0 2.763 1.214 2.763 2.734s-1.248 2.734-2.763 2.734a2.754 2.754 0 0 1-2.74-2.376l1.487-.197c.08.597.603 1.073 1.253 1.073.707 0 1.263-.562 1.263-1.234 0-.672-.556-1.234-1.263-1.234a1.27 1.27 0 0 0-1.028.516l-.01.014-.189.233-1.314-.639L10.819.5zM4.491.695c0 .307-.346.762-1.044.762h-.276v1.5h1.32V8h1.5V.695h-1.5zm10.818 9.835-1.97 1.97 1.97 1.97-1.06 1.06-1.97-1.97-1.97 1.97-1.06-1.06 1.969-1.97-1.97-1.97 1.06-1.06 1.97 1.97 1.97-1.97 1.06 1.06zM8.085 8.42a.956.956 0 1 0 0-1.913.956.956 0 0 0 0 1.913z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M15.454.985h5.84v2h-4.247l-.412 1.794a4.26 4.26 0 0 1 1.304-.203c2.318 0 4.221 1.856 4.221 4.175 0 2.32-1.903 4.175-4.22 4.175-2.134 0-3.913-1.57-4.186-3.628l1.983-.263c.14 1.056 1.063 1.89 2.202 1.89 1.24 0 2.221-.986 2.221-2.174s-.98-2.175-2.22-2.175c-.747 0-1.403.359-1.806.908l-.013.018-.3.37-1.752-.852L15.454.985zm-3.715 11.689a.96.96 0 1 0 0-1.92.96.96 0 0 0 0 1.92zm10.303 3.923L19.5 19.14l2.543 2.543-1.414 1.414-2.543-2.543-2.543 2.543-1.414-1.415 2.543-2.542-2.543-2.543 1.414-1.415 2.543 2.543 2.543-2.543 1.414 1.415zM7.002.985c0 .634-.679 1.42-1.87 1.42h-.443v2h2.313v8.269h2V.985h-2z\'/>'
  }];
  var iconSizeValue = props.size ? IconSizeMap[props.size] : props.iconSize;
  var closestSize = findClosestGlyphAvailable(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}
/**
 * @deprecated The name IconPlaybackSpeed1point5x is deprecated and will be archived soon. Use IconPlaybackSpeed1Point5x (with 'Point' capitalized) instead.
 */
export function IconPlaybackSpeed1point5x(props) {
  return /*#__PURE__*/React.createElement(IconPlaybackSpeed1Point5x, props);
}

/**
 * @deprecated The name Experimental__IconPlaybackSpeed1Point5x is deprecated and will be archived soon. Use IconPlaybackSpeed1Point5x instead.
 */
export function Experimental__IconPlaybackSpeed1Point5x(props) {
  return /*#__PURE__*/React.createElement(IconPlaybackSpeed1Point5x, props);
}